import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackScimTokenRevoked.meta';

export type UseTrackScimTokenRevokedParams = {
  location: 'workspace-settings-security';
};

export const useTrackScimTokenRevoked = () => {
  const { track } = useAnalyticsUtilities();

  const trackScimTokenRevoked = useCallback(
    (params: UseTrackScimTokenRevokedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackScimTokenRevoked };
};
